module.exports = __webpack_public_path__ + "img/社会综治-数据中台软件V2.0.6d6190f0.jpg";